export enum Permission {
  ENTER_COURSE = "ENTER_COURSE",
  ASSIGN_COURSE = "ASSIGN_COURSE",
  STUDENT_MANAGE = "STUDENT_MANAGE",

  // New
  // Dashboard
  DASHBOARD = "dashboard",

  // Job Management
  JOB = "job",
  JOB_PENDING = "job_pending",
  JOB_FINISHED = "job_finished",
  JOB_CREDIT_REP = "job_credit_rep",

  // Customer Management
  CUSTOMER = "customer",
  CUSTOMER_GROUP = "customer_group",
  CUSTOMER_STATS = "cust_stats",
  CREDIT_CUSTOMER = "credit_cust",

  // Car Management
  CAR = "car",
  SERIE = "serie",

  // Import & File Management
  DAILY_IMPORT = "daily_import",
  AFI_LIST = "afi_list",
  AFC_LIST = "afc_list",
  ACP_LIST = "acp_list",
  CHECK_AFI_FILE = "check_afi_file",
  CHECK_AFC_FILE = "check_afc_file",
  CHECK_ACP_FILE = "check_acp_file",

  // Insurance
  INSURANCE = "insurance",
  INSURANCE_STATS = "insurance_stats",
  INSURANCE_CUSTOMER = "insurance_cust",

  // Campaign & Discount
  CAMPAIGN_SETTING = "campaign_setting",
  CAMPAIGN_JOB = "campaign_job",
  DISCOUNT_TYPE = "discount_type",
  CHECK_DISCOUNT = "check_discount",

  // Financial
  PART_JOB = "part_job",
  CLAIM_SUMMARY = "claim_summary",
  COMPANY_DEBTOR_SETTING = "company_debtor_setting",
  CREDIT_DEBTOR_SETTING = "credit_debtor_setting",

  // Administration
  USER = "user",
  ROLE = "role",
  DEALER_BRANCH = "dealer_branch",
  STAFFS = "staffs",
  POSITION = "position",
  TEAM = "team",
  TEAM_STATUS = "team_status",

  // Settings
  LINE_NOTIFY_SETTING = "line_notify_setting",
  PENDING_JOB_LOCATION_SETTING = "pending_job_location_setting",
  DEBTOR_JOB_STATUS_MASTER_SETTING = "debtor_job_status_master_setting",

  // Reports
  REPORT = "report",
  REPORT_FILE_STATUS = "report_file_status",
}
